import Typography from "@portal/components/atoms/v2/typography";
import { OnMonthlyAmountChange, OnStartAmountChange } from "../../../components/handlers";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";
import { IInputOptionsProps } from "../types";
import Input from "@portal/components/atoms/v2/input";
import { Field } from "@headlessui/react";
import { AvailableLiquidity } from "@portal/types/robot/IRobotEnums";

export const InputOptions = ({
  isValidMonthlyAmount,
  isValidOneTimeDeposit,
  request,
  isDefaultLanguage,
  setMonthlyAmount,
  setOneTimeDeposit,
  availableLiquidity,
  setNotEnoughLiquidity,
  savingsToday,
  setNotEnoughSavings,
  setAboveMaxAmount,
}: IInputOptionsProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <>
      <div className="flex mt-2">
        <Typography variant="Bold">{texts.PAGE_13_MONTHLY_SAVING}</Typography>
      </div>
      <div className="border border-blueLight rounded-md">
        <Input
          className="text-right"
          type="number"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const amount = e.target.value;
            if (Number(amount) <= 100000) {
              OnMonthlyAmountChange(amount, setMonthlyAmount);
            }
            if (
              (availableLiquidity === AvailableLiquidity.From100To2000 && Number(amount) > 2000) ||
              (availableLiquidity === AvailableLiquidity.From2000To10000 && Number(amount) > 10000) ||
              Number(amount) > 100000
            ) {
              setNotEnoughLiquidity(true);
            }
          }}
          value={request.monthlyAmount.toString()}
        />
      </div>
      <div className="flex" style={{ marginBottom: `${!isValidMonthlyAmount ? 0 : 10}px` }}>
        <Typography variant="Body">{texts.PAGE_13_MONTHLY_AVERAGE}</Typography>
      </div>
      {!isValidMonthlyAmount && (
        <div className="flex mb-2">
          <InfoBoxComponent texts={[texts.VALIDATION_MIN_AMOUNT]} />
        </div>
      )}
      <InfoBoxComponent header={texts.PAGE_13_SUBHEADER_INFO_QUESTION} texts={[texts.PAGE_13_SUBHEADER_INFO]} />
      <div className="flex mt-2.5">
        <Typography variant="Bold">{texts.PAGE_13_START_AMOUNT}</Typography>
      </div>
      <Field className="border border-blueLight rounded-md">
        <Input
          className="text-right"
          type="number"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const amount = e.target.value;
            if (Number(amount) > 1000000) {
              setAboveMaxAmount(true);
              return;
            }
            OnStartAmountChange(amount, setOneTimeDeposit);
            if ((savingsToday === 1 && Number(amount) > 150000) || (savingsToday === 2 && Number(amount) > 500000)) {
              setNotEnoughSavings(true);
            }
          }}
          value={request.oneTimeDeposit.toString()}
        />
      </Field>
      {!isValidOneTimeDeposit && (
        <div className="flex mb-2.5">
          <InfoBoxComponent texts={[texts.VALIDATION_START_AMOUNT]} />
        </div>
      )}
      {request.oneTimeDeposit > 100000 && (
        <div className="flex mb-2.5">
          <InfoBoxComponent texts={[texts.VALIDATION_START_AMOUNT_WARNING]} />
        </div>
      )}
      {request.oneTimeDeposit === 0 && request.monthlyAmount === 0 && (
        <div className="flex mb-2.5">
          <InfoBoxComponent texts={[texts.VALIDATION_START_AMOUNT_AND_MONTHLY_WARNING]} />
        </div>
      )}
    </>
  );
};
